import { createFileRoute } from '@tanstack/react-router';
import EmailUnificationPage from '@/features/account/email-unification';

// EU-636 — tela "Escolha um e-mail" (unificação de conta por CPF). Alcançada
// pelo gate de pendência (HomeGate/RootRedirect) após o link do e-mail.
export const Route = createFileRoute('/escolher-email')({
  component: EmailUnificationPage,
});
